import { CmtsMasterDataCrudShell } from "../components/master-data/index.js";

export function CmtsSeverityPage() {
  return <CmtsMasterDataCrudShell entityKey="severity" />;
}

export default CmtsSeverityPage;
